export type ModelKey = { providerID: string; modelID: string }
export type RecentModel = ModelKey & { variant: string | null; usedAt: number }

const RECENT_MODEL_LIMIT = 5

/** Thinking level is part of identity: Sol · Max and Sol · Low are distinct workflows. */
export function recentModelKey(model: ModelKey & { variant?: string | null }) {
  return `${model.providerID}:${model.modelID}:${model.variant ?? ""}`
}

export function normalizeRecentModels(value: unknown): RecentModel[] {
  if (!Array.isArray(value)) return []
  const entries: RecentModel[] = []
  const seen = new Set<string>()

  for (const item of value) {
    if (!item || typeof item !== "object") continue
    const { providerID, modelID, variant, usedAt } = item as Record<string, unknown>
    if (typeof providerID !== "string" || !providerID.trim()) continue
    if (typeof modelID !== "string" || !modelID.trim()) continue
    const recentVariant = variant === null ? null : typeof variant === "string" && variant ? variant : undefined
    if (recentVariant === undefined) continue
    if (typeof usedAt !== "number" || !Number.isFinite(usedAt)) continue

    const entry: RecentModel = { providerID, modelID, variant: recentVariant, usedAt }
    const key = recentModelKey(entry)
    if (seen.has(key)) continue
    seen.add(key)
    entries.push(entry)
    if (entries.length === RECENT_MODEL_LIMIT) break
  }

  return entries
}

export function addRecentModel(current: RecentModel[], model: ModelKey & { variant?: string | null }, usedAt = Date.now()) {
  const entry: RecentModel = {
    providerID: model.providerID,
    modelID: model.modelID,
    variant: model.variant ?? null,
    usedAt,
  }
  return [entry, ...current.filter((item) => recentModelKey(item) !== recentModelKey(entry))].slice(0, RECENT_MODEL_LIMIT)
}
